export abstract class Constants {
    static readonly USER_USER_ID_MIN_LENGTH = 4;
    static readonly USER_USER_ID_MAX_LENGTH = 20;
    static readonly USER_FULL_NAME_MIN_LENGTH = 4;
    static readonly USER_FULL_NAME_MAX_LENGTH = 100;
    static readonly USER_PASSWORD_MIN_LENGTH = 8;
    static readonly USER_PASSWORD_MAX_LENGTH = 32;

}